module.exports = __webpack_public_path__ + "img/logo_bul.cda0b9a0.png";